var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injector, OnInit } from '@angular/core';
import { ContactBaseComponent } from './../common-theme/index';
import { OpenModalService } from '../common-theme/base-components/shared/modals/open-modal.service';
import { AgencyService } from '../common-theme/api/agency.service';
var ContactComponent = /** @class */ (function (_super) {
    __extends(ContactComponent, _super);
    function ContactComponent(injector, agencyService, window, document, openModalService) {
        var _this = _super.call(this, injector, agencyService, window) || this;
        _this.document = document;
        _this.openModalService = openModalService;
        return _this;
    }
    ContactComponent.prototype.openMessageModal = function () {
        this.openModalService.showContactFormModal();
        if (this.document)
            this.document.body.classList.add('no-scroll');
    };
    ContactComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.setTitle('Contactează echipa proiectului Romanescu Park Residence');
        this.setMetaDescription("\n      O locuin\u021B\u0103 la Romanescu Park Residence \u00EE\u021Bi va aduce o via\u021B\u0103 nou\u0103, mai aproape de natur\u0103.\n      Contacteaz\u0103-ne la num\u0103rul de telefon: +40726307128 dac\u0103 vrei s\u0103 afli mai multe detalii despre\n      apartamentele noastre.\n    ");
    };
    return ContactComponent;
}(ContactBaseComponent));
export { ContactComponent };



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts.pre-build-optimizer.js